export default {
    data() {
        return {};
    },
    methods: {
        getValueForField(field) {
            let matchingField;

            if (this.pipeFlow === 'Upstream' && this.reportSettings.OtherActionSettings.chkReverseHeaderManholes) {
                if (field.toLowerCase() === 'startid') {
                    matchingField = this.headerOptionsAndValues.find((f) => f.LabelText === 'End ID')
                }
                else if (field === 'endid') {
                    matchingField = this.headerOptionsAndValues.find((f) => f.LabelText === 'Start ID')
                }
                else {
                    matchingField = this.headerOptionsAndValues.find((f) => {
                        return f.LabelText === field || f.Name === field;
                    });
                }
            }
            else {
                matchingField = this.headerOptionsAndValues.find((f) => {
                    return f.LabelText === field || f.Name === field;
                });
            }
            
            if (matchingField) {
                if (matchingField.Value) {
                    return matchingField.Value;
                }
            }

            return '';
        },
        getLabelForField(field) {
            let matchingField;

            matchingField = this.headerOptionsAndValues.find((f) => {
                return f.LabelText === field || f.Name === field;
            });
            
            if (matchingField) {
                if (matchingField.LabelText) {
                    return matchingField.LabelText;
                }
            }

            return '';
        },
        getRowsForHeaders(data) {
            let rows = [];

            let inputs = Object.entries(data);

            for (let i = 0; i < inputs.length; i += 2) {
                let row = [];

                if (inputs[i][1]) {
                    row.push(`${this.getLabelForField(inputs[i][1])}: ${this.getValueForField(inputs[i][1])}`);
                }

                if (i + 1 < inputs.length && inputs[i + 1][1]) {
                    row.push(`${this.getLabelForField(inputs[i + 1][1])}: ${this.getValueForField(inputs[i + 1][1])}`);
                }

                if (row.length) {
                    rows.push(row);
                }
            }

            return rows;
        },
    }
};
